<template>
    <div>
        <table class="table table-hover">
            <thead class="thead-light sticky">
                <tr>
                    <th v-for="(dato, dkey) in tabla.attr" :key="dkey">
                        {{ dato.pretty_name }}
                    </th>

                    <th v-if="valores_tabla[0].etapa_actual == valores_tabla[0].etapa_campo || (valores_tabla[0].etapa_actual == 0 && valores_tabla[0].estado_ficha == 'A')"></th>
                </tr>
            </thead>
            <tbody class="table-body">
                <tr v-for="(resultado, rkey) in datos_tabla" :key="rkey">
                    <td v-for="(dato, dkey) in resultado.attr" :key="dkey">
                        <input
                            v-if="dato.type == 'ficha'"
                            :id="dkey"
                            v-model="value[dato.name]"
                            :name="dato.name"
                            class="form-control"
                            type="text"
                            @input="edit++"
                            v-bind="normalizeExtra(dato.extra)"
                            @blur="
                                ($even) =>
                                    buscarInformacionFicha(
                                        $even,
                                        dato,
                                        value[dato.name],
                                        resultado.attr
                                    )
                            "
                        />
                        <input
                            v-if="dato.type == 'text'"
                            :id="dkey"
                            v-model="value[dato.name]"
                            :name="dato.name"
                            class="form-control"
                            type="text"
                            @input="edit++"
                            v-bind="normalizeExtra(dato.extra)"
                        />

                        <input
                            v-if="dato.type == 'date'"
                            :id="dkey"
                            v-model="value[dato.name]"
                            :name="dato.name"
                            class="form-control"
                            type="date"
                            v-bind="normalizeExtra(dato.extra)"
                            @input="edit++"
                            :placeholder="dato.placeholder"
                        />
                        <input
                            v-if="dato.type == 'time'"
                            :id="dkey"
                            v-model="value[dato.name]"
                            :name="dato.name"
                            class="form-control"
                            type="time"
                            v-bind="normalizeExtra(dato.extra)"
                            @input="edit++"
                            :placeholder="dato.placeholder"
                        />

                        <input
                            v-if="dato.type == 'number'"
                            :id="dkey"
                            v-model="value[dato.name]"
                            class="form-control"
                            type="number"
                            @input="edit++"
                            :name="dato.name"
                            v-bind="normalizeExtra(dato.extra)"
                        />
                        <input
                            v-if="dato.type == 'hidden'"
                            :id="dkey"
                            :name="dato.name"
                            v-model="dato.value"
                            class="form-control hiddenValue"
                            type="hidden"
                            v-bind="normalizeExtra(dato.extra)"
                        />

                        <v-select
                            :name="dato.name"
                            v-else-if="dato.type == 'select'"
                            v-model="value[dato.name]"
                            v-bind="normalizeExtra(dato.extra)"
                            @input="edit++"
                            @search="
                                (search, loading) =>
                                    onSearch(search, loading, dato, dato.name)
                            "
                            :options="dato.options"
                            :id="dkey"
                            :create-option="
                                (value) => ({
                                    label: value,
                                    code: value,
                                })
                            "
                            :reduce="(value) => value.code"
                        >
                        </v-select>

                        <div v-if="dato.type == 'html'">
                            <vue-editor v-model="value[dato.name]">
                            </vue-editor>
                            <textarea
                                :name="dato.name"
                                hidden
                                v-model="value[dato.name]"
                                :id="dkey"
                                cols="30"
                                rows="10"
                                v-bind="normalizeExtra(dato.extra)"
                            >
                            </textarea>
                        </div>
                        <div v-else-if="dato.type == 'textarea'">
                            <textarea
                                :name="dato.name"
                                v-model="value[dato.name]"
                                :id="dkey"
                                cols="30"
                                rows="10"
                                class="form-control"
                                v-bind="normalizeExtra(dato.extra)"
                            >
                            </textarea>
                        </div>

                        <div v-else-if="dato.type == 'imagen'">
                            <img
                                :id="'key_' + dkey + '_' + key2 + '_img'"
                                :src="
                                    value[dato.name]
                                        ? value[dato.name]
                                        : '/img/image-default.webp'
                                "
                                v-on:click.prevent="
                                    ClickImagen('key_' + dkey + '_' + key2)
                                "
                                style="cursor: pointer; max-width: 100%"
                            />
                            <input
                                :name="dato.name"
                                v-bind="normalizeExtra(dato.extra)"
                                type="file"
                                :id="'key_' + dkey + '_' + key2"
                                :ref="dkey"
                                @change="
                                    (event) =>
                                        ImagenDestacada(
                                            event,
                                            value,
                                            dato.name,
                                            'key_' + dkey + '_' + key2 + '_img'
                                        )
                                "
                                style="display: none"
                            />
                        </div>

                        <div
                            v-else-if="dato.type == 'file'"
                            style="width: 100%"
                        >
                            <div
                                class="file-types-div"
                                v-for="(file, keyFile) in valueTMP[dato.name]"
                                v-bind:key="keyFile"
                            >
                                <img
                                    :id="'key_' + dkey + '_' + key2 + '_file'"
                                    :src="'/img/book.png'"
                                    :title="file.name"
                                    class="file-types-image"
                                />
                                <span
                                    :id="
                                        'key_' +
                                        dkey +
                                        '_' +
                                        key2 +
                                        '_' +
                                        key2 +
                                        '_file_span'
                                    "
                                    class="file-types-text"
                                    >{{ file.type }}</span
                                >
                                <button
                                    type="button"
                                    class="btn btn-sm btn-danger file-types-trash"
                                    @click="
                                        (event) =>
                                            FileDelete(dato, dato.name, keyFile)
                                    "
                                >
                                    <i class="fa fa-times"></i>
                                </button>
                                <button
                                    v-if="typeof file.id == 'number'"
                                    type="button"
                                    class="btn btn-sm btn-success file-types-check"
                                >
                                    <i class="fa fa-check"></i>
                                </button>
                            </div>
                            <div class="file-types-div">
                                <img
                                    :id="'key_' + dkey + '_' + key2 + '_file'"
                                    :src="'/img/book-plus.png'"
                                    v-on:click.prevent="
                                        ClickImagen('key_' + dkey + '_' + key2)
                                    "
                                    class="file-types-image"
                                />
                                <span
                                    :id="
                                        'key_' +
                                        dkey +
                                        '_' +
                                        key2 +
                                        '_file_span'
                                    "
                                    class="file-types-text"
                                ></span>
                                <input
                                    :name="dato.name"
                                    type="file"
                                    v-bind="normalizeExtra(dato.extra)"
                                    :id="'key_' + dkey + '_' + key2"
                                    :ref="dkey"
                                    @change="
                                        (event) =>
                                            FileChange(
                                                event,
                                                value,
                                                dato.name,
                                                'key_' + dkey + '_' + key2,
                                                dato.name
                                            )
                                    "
                                    style="display: none"
                                />
                            </div>
                        </div>

                        <div
                            v-else-if="dato.type == 'checkbox'"
                            class="form-check"
                        >
                            <input
                                :name="dato.name"
                                class="form-check-input"
                                type="checkbox"
                                :id="dkey"
                                v-model="value[dato.name]"
                                v-bind="normalizeExtra(dato.extra)"
                            />
                        </div>
                    </td>
                    <td v-if="valores_tabla[0].etapa_actual == valores_tabla[0].etapa_campo || (valores_tabla[0].etapa_actual == 0 && valores_tabla[0].estado_ficha == 'A')">
                        <button
                            type="button"
                            class="btn btn-xs btn-danger pull-right"
                            @click="eliminarFila(rkey)"
                        >
                            <i class="fa fa-minus" aria-hidden="true"></i>
                        </button>
                    </td>
                </tr>
                <tr v-if="valores_tabla[0].etapa_actual == valores_tabla[0].etapa_campo || (valores_tabla[0].etapa_actual == 0 && valores_tabla[0].estado_ficha == 'A')">
                    <th v-for="(dato, dkey) in tabla.attr" :key="dkey"></th>
                    <td>
                        <button
                            @click="AgregarFila"
                            type="button"
                            class="btn btn-xs btn-success pull-right"
                        >
                            <i class="fa fa-plus" aria-hidden="true"></i>
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>
        <!-- <pre>{{ datos_tabla }}</pre> -->
        <input type="hidden" v-model="edit" />
    </div>
</template>
<style>
.container-height {
    display: table;
}

.options {
    display: table-row;
}

.container-height-body {
    display: table-cell;
}

.unselectable {
    display: table-cell;
}
</style>
<script type="text/javascript">
export default {
    props: [
        "watch",
        "form",
        "tabla",
        "valores_tabla",
        "title",
        "footer",
        "submit_url",
        "submit_in_url",
        "redirect_submit_url",
        "edit_get_url",
        "etapa",
    ],
    data() {
        return {
            datos_tabla: {},
            config: {},
            value: {},
            valueTMP: {},
            edit: 0,
            numero_array: 10000,
        };
    },
    computed: {},
    methods: {
        normalizeExtra(extra) {
            if (!extra) {
                return {};
            }

            if (Array.isArray(extra)) {
                return Object.assign(
                    {},
                    ...extra.filter(
                        (item) => item && typeof item === "object"
                    )
                );
            }

            if (typeof extra === "object") {
                const merged = Object.assign({}, extra);
                Object.keys(merged).forEach((k) => {
                    if (/^\d+$/.test(k)) {
                        delete merged[k];
                    }
                });
                return merged;
            }

            return {};
        },
        buscarInformacionFicha(event, dato, value, fila) {
            const data = {
                ficha: value,
            };
            this.$root
                .Consulta(
                    dato.url,
                    data,
                    "post",
                    false,
                    false,
                    false,
                    "",
                    false
                )
                .then((response) => {
                    fila.forEach((item) => {
                        const claveNormalizada = this.normalizarString(
                            item.pretty_name
                        );
                        Object.keys(response).forEach((key) => {
                            if (
                                claveNormalizada === this.normalizarString(key)
                            ) {
                                this.value[item.name] = response[key];
                            }
                        });
                    });
                    this.edit++;
                });
        },
        AgregarFila() {
            this.edit++;

            let nuevoObjeto = JSON.parse(JSON.stringify(this.tabla));

            this.numero_array++;
            let nuevoIndice = this.numero_array;

            nuevoObjeto.attr.forEach((attr) => {
                let str = attr.name;
                const regex = /\[(\d+)\]/g;
                let matches;
                let indices = [];

                while ((matches = regex.exec(str)) !== null) {
                    indices.push(matches[1]);
                }

                indices[2] = parseInt(indices[2], 10) + nuevoIndice;

                let newStr = str.replace(/\[\d+\]/g, function () {
                    return `[${indices.shift()}]`;
                });

                attr.name = newStr;
            });

            this.datos_tabla.push(nuevoObjeto);
        },
        eliminarFila(indice) {
            this.edit++;

            this.datos_tabla.splice(indice, 1);
        },
        normalizarString(s) {
            this.edit++;

            return s
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "")
                .toLowerCase()
                .replace(/[^a-z0-9]/gi, "");
        },
        ClickImagen(key) {
            $("#" + key).click();
        },
        FileChange: function (event, image, key, keyFIle, valueName) {
            let input = event.target;

            if (input.files && input.files[0]) {
                let n = this;
                let cont = 0;
                let newTemp = [];
                let newVal = [];

                for (let index in n.valueTMP[valueName]) {
                    if (typeof n.valueTMP[valueName][index].id == "number") {
                        newTemp[cont] = n.valueTMP[valueName][index];
                        newVal[cont] = n.valueTMP[valueName][index].id;
                        cont++;
                    }
                }

                n.valueTMP[valueName] = newTemp;
                n.value[valueName] = newVal;

                for (let index = 0; index < input.files.length; index++) {
                    let name = input.files[index].name;
                    let type = name.match(/\.[0-9a-z]+$/i);

                    n.valueTMP[valueName].push({
                        name: name,
                        type: type[0],
                    });

                    n.value[valueName][cont] = input.files[index];
                    cont++;
                }
                n.edit++;
            }
        },
        FileDelete: function (row, name, key) {
            if (typeof this.valueTMP[name][key].id != "undefined") {
                this.$swal
                    .fire({
                        title: "Eliminar Archivo?",
                        text: "Este archivo ya se encuentra registrado, de eliminarlo se perdera todo rastro de el, recuerde guardar para que surja efecto!",
                        icon: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#3085d6",
                        cancelButtonColor: "#d33",
                        confirmButtonText: "Si!",
                        cancelButtonText: "Cancelar",
                    })
                    .then((result) => {
                        if (!result.isDenied && !result.isDismissed) {
                            this.FileDeleteConfirm(row, name, key);
                        }
                    });
            } else {
                this.FileDeleteConfirm(row, name, key);
            }
        },
        FileDeleteConfirm(row, name, key) {
            let newArray = [];

            for (let index = 0; index < this.value[name].length; index++) {
                if (
                    this.value[name][index].name !=
                        this.valueTMP[name][key].name &&
                    this.value[name][index] != this.valueTMP[name][key].id
                ) {
                    newArray.push(this.value[name][index]);
                }
            }

            this.valueTMP[name].splice(key, 1);
            this.value[name] = newArray;

            this.edit++;
        },
        ImagenDestacada: function (event, image, key, keyimg) {
            let input = event.target;
            if (input.files && input.files[0]) {
                let reader = new FileReader();
                let n = this;
                reader.onload = function (e) {
                    $("#" + event.target.id).attr("src", e.target.result);
                    $("#" + keyimg).attr("src", e.target.result);
                    n.value[key] = e.target.result;
                    image[key] = e.target.result;
                };
                reader.readAsDataURL(input.files[0]); // convert to base64 string
            }
        },
        inicializar(model) {
            switch (model.type) {
                case "select":
                    if (typeof this.value[model.name] == "undefined") {
                        let split = model.name.split(".");
                        if (
                            split.length == 2 &&
                            typeof this.value[split[0]] != "undefined" &&
                            typeof this.value[split[0]][split[1]] != "undefined"
                        ) {
                            this.value[split[0] + "." + split[1]] =
                                this.value[split[0]][split[1]];
                        }
                    }

                    if (
                        typeof model.ajax == "object" &&
                        typeof this.value[model.name] != "undefined" &&
                        typeof model.extra != "undefined" &&
                        typeof model.extra.multiple != "undefined" &&
                        model.extra.multiple == true
                    ) {
                        let options2 = JSON.parse(
                            JSON.stringify(this.value[model.name])
                        );
                        this.value[model.name] = [];
                        for (let index in options2) {
                            this.value[model.name][index] =
                                options2[index].code;
                        }
                    } else if (
                        typeof model.ajax == "object" &&
                        typeof this.value[model.name] != "undefined"
                    ) {
                        let option2 = this.value[model.name];
                        model.options = JSON.parse(
                            JSON.stringify(this.value[model.name])
                        );
                        this.value[model.name] = option2[0].code;
                    }
                    this.edit++;

                    break;
                case "file":
                    if (
                        typeof this.valueTMP[model.name] == "undefined" &&
                        typeof this.value[model.name] != "undefined"
                    ) {
                        this.valueTMP[model.name] = this.value[model.name];
                        let newArray = [];
                        let cont = 0;
                        for (let index in this.value[model.name]) {
                            newArray[index] = this.value[model.name][index].id;
                        }
                        this.value[model.name] = newArray;
                    }
                    break;
                case "hidden":
                case "number":
                case "text":
                case "date":
                    if (typeof this.value[model.name] == "undefined") {
                        let split = model.name.split(".");
                        if (
                            split.length == 2 &&
                            typeof this.value[split[0]] != "undefined" &&
                            typeof this.value[split[0]][split[1]] != "undefined"
                        ) {
                            this.value[split[0] + "." + split[1]] =
                                this.value[split[0]][split[1]];
                        }
                    }
                    break;

                default:
                    break;
            }
            this.edit++;
        },
        RedirectButton: function (route) {
            this.$router.push({ name: route });
        },
        onSearch(search, loading, option, odefault) {
            if (
                typeof option.options[0] == "undefined" ||
                typeof option.options[0].search == "undefined" ||
                option.options[0].search != false
            ) {
                if (
                    typeof this.value[option.name] != "undefined" &&
                    typeof this.value[option.name][0] == "object"
                ) {
                    option.options = this.value[odefault];
                    this.value[odefault] = [];
                    for (let index in option.options) {
                        this.value[odefault][index] =
                            option.options[index].code;
                    }
                }

                if (typeof option.ajax != "undefined" && search.length) {
                    loading(true);
                    let url = option.ajax.url + "?q=" + escape(search);
                    this.search(loading, search, option, url, this);
                }
            }
        },
        search: _.debounce((loading, search, option, url, n) => {
            let data = {
                label: option.ajax.label,
                code: option.ajax.code,
                filtro: {},
            };

            data["filtro"][option.ajax.filter] = search;

            n.$root
                .Consulta(url, data, "post", false, false, false, "", false)
                .then((response) => {
                    let newValues = [];
                    n.value[option.name] = [];
                    let cont = 0;
                    for (let temp in n.value[option.name]) {
                        let temp2 = option.options.find(
                            (element) =>
                                element.code == n.value[option.name][temp]
                        );
                        if (
                            typeof temp2 != "undefined" &&
                            typeof temp2.code != "undefined" &&
                            typeof response.find(
                                (element) => element.code == temp2.code
                            ) == "undefined" &&
                            Number.isInteger(temp2.code)
                        ) {
                            newValues[cont] = temp2;
                            cont++;
                        }
                    }
                    option.options = [];
                    option.options = response.concat(newValues);
                    loading(false);
                });
        }, 350),
    },
    mounted() {},
    created() {
        this.datos_tabla = JSON.parse(JSON.stringify(this.valores_tabla));

        this.config = this.form;
        let this2 = this;

        for (let index in this.datos_tabla) {
            for (let index2 in this.datos_tabla[index].attr) {
                this.value[this.datos_tabla[index].attr[index2].name] = this.datos_tabla[index].attr[index2].value;
            }
        }
        this.edit++;
    },
    updated() {
        this.config = this.form;
        let this2 = this;
        for (var key in this.config) {
            for (var key2 in this.config[key]) {
                for (var key3 in this.config[key][key2].attrs) {
                    for (var dkey in this.config[key][key2].attrs[key3]) {
                        if (
                            this.config[key][key2].attrs[key3][dkey].value !==
                            ""
                        ) {
                            this.value[
                                this.config[key][key2].attrs[key3][dkey].name
                            ] = this.config[key][key2].attrs[key3][dkey].value;
                        }
                    }
                }
            }
        }
    },
    watch: {
        value: {
            handler(newValue) {
                this.$emit("cambios", {
                    values: newValue,
                    etapa: this.etapa,
                });
            },
            deep: true,
        },
    },
};
</script>
